import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CrossDeviceLogin from '../components/CrossDeviceLogin';
import { Root, StyledHeading } from '../components/styles/styles';
import StyledSection from '../components/styles/StyledSection';

export default function CrossDeviceLoginPage() {
  const navigate = useNavigate();

  return (
    <Root>
      <StyledSection tone="tone1">
        <Box display="flex" alignItems="center" mb={2}>
          <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/login')} sx={{ mr: 2 }}>
            Back to Login
          </Button>
        </Box>

        <StyledHeading>Sign In with Mobile</StyledHeading>

        <Box mb={3}>
          <Typography variant="body1" color="text.secondary" textAlign="center">
            Use your mobile device to sign in to this desktop session
          </Typography>
        </Box>

        <CrossDeviceLogin />

        <Box mt={4} textAlign="center">
          <Typography variant="body2" color="text.secondary">
            Don't have the mobile app?{' '}
            <Button variant="text" size="small" onClick={() => navigate('/login')}>
              Sign in with password instead
            </Button>
          </Typography>
        </Box>
      </StyledSection>
    </Root>
  );
}
